// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Table {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.TextOverflow {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.FixedRowContent {
    overflow: hidden;
    flex: 1 0 auto;
}

.SelectBox {
    width: 50px;
    left: 0;
    position: sticky;
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 0 0 50px;
    height: 100%;
    background: var(--datatable-header-background);
    z-index: 9;
}

.ExpandBox {
    width: 25px;
    height: 100%;
    left: 0;
    position: sticky;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex: 0 0 25px;
    background: var(--datatable-header-background);
    z-index: 9;
}

/**************************************************/
/*                 DataTable                      */
/**************************************************/
.TableContent {
    flex: 1 1 auto;
    height: 100%;
}

.TableBody {
  flex: 1 1 auto;
  width: 100%;
  position:relative;
}

.TableBodyContent {
  height: 100%;
  overflow: auto;
}

.TableFooter {
  border-top: 1px solid black;
  height: 50px;
}

.TableContainer {
  overflow: auto;
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
}

.TableScroll {
  height: 100%;
  overflow: auto;
  width: 25px;
}

/**************************************************/
/*            DataTable Header                    */
/**************************************************/
.TableHeader {
  display: table-header-group;
  max-width: 100%;
  display: flex;
  overflow: hidden;
  position: relative;
  align-self: flex-start;
  flex-direction:column;
}

.TableHeaderRow {
    display: flex;
    overflow: hidden;
    position: relative;
    border-bottom: 1px solid var(--datatable-line);
    background: var(--datatable-header-background);
    color: var(--datatable-header-foreground);
}

/**********************************************************/
/*                  SpreadSheet                           */
/**********************************************************/
.SpreadSheetHeader {
  display: table-header-group;
  max-width: 100%;
  display: flex;
  overflow: hidden;
}

.SpreadSheetHeaderRow {
    display: flex;
    overflow: hidden;
    background: var(--spreadsheet-header-background);
    color: var(--spreadsheet-header-foreground);
}
.SpreadSheetHeaderCell {
    display: flex;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border: 1px solid var(--spreadsheet-line);
    border-bottom: 2px double var(--spreadsheet-line);
}

/**********************************************************/
/*                  Loading                               */
/**********************************************************/
.LoadingIndicator {
  height: 5px;
}
.LoadingOverlay {
  position: absolute;
  background: black;
  opacity: 0.5;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/components/datatable/datatable.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,OAAO;IAEP,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,8CAA8C;IAC9C,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,OAAO;IAEP,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,8CAA8C;IAC9C,UAAU;AACd;;AAEA,mDAAmD;AACnD,mDAAmD;AACnD,mDAAmD;AACnD;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,WAAW;AACb;;AAEA,mDAAmD;AACnD,mDAAmD;AACnD,mDAAmD;AACnD;EACE,2BAA2B;EAC3B,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,8CAA8C;IAC9C,8CAA8C;IAC9C,yCAAyC;AAC7C;;AAEA,2DAA2D;AAC3D,2DAA2D;AAC3D,2DAA2D;AAC3D;EACE,2BAA2B;EAC3B,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,gDAAgD;IAChD,2CAA2C;AAC/C;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,yCAAyC;IACzC,iDAAiD;AACrD;;AAEA,2DAA2D;AAC3D,2DAA2D;AAC3D,2DAA2D;AAC3D;EACE,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;AACX","sourcesContent":[".Table {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  overflow: hidden;\n}\n\n.TextOverflow {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.FixedRowContent {\n    overflow: hidden;\n    flex: 1 0 auto;\n}\n\n.SelectBox {\n    width: 50px;\n    left: 0;\n    position: -webkit-sticky;\n    position: sticky;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    flex: 0 0 50px;\n    height: 100%;\n    background: var(--datatable-header-background);\n    z-index: 9;\n}\n\n.ExpandBox {\n    width: 25px;\n    height: 100%;\n    left: 0;\n    position: -webkit-sticky;\n    position: sticky;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    flex: 0 0 25px;\n    background: var(--datatable-header-background);\n    z-index: 9;\n}\n\n/**************************************************/\n/*                 DataTable                      */\n/**************************************************/\n.TableContent {\n    flex: 1 1 auto;\n    height: 100%;\n}\n\n.TableBody {\n  flex: 1 1 auto;\n  width: 100%;\n  position:relative;\n}\n\n.TableBodyContent {\n  height: 100%;\n  overflow: auto;\n}\n\n.TableFooter {\n  border-top: 1px solid black;\n  height: 50px;\n}\n\n.TableContainer {\n  overflow: auto;\n  width: 100%;\n  height: 100%;\n  max-width: 100%;\n  max-height: 100%;\n}\n\n.TableScroll {\n  height: 100%;\n  overflow: auto;\n  width: 25px;\n}\n\n/**************************************************/\n/*            DataTable Header                    */\n/**************************************************/\n.TableHeader {\n  display: table-header-group;\n  max-width: 100%;\n  display: flex;\n  overflow: hidden;\n  position: relative;\n  align-self: flex-start;\n  flex-direction:column;\n}\n\n.TableHeaderRow {\n    display: flex;\n    overflow: hidden;\n    position: relative;\n    border-bottom: 1px solid var(--datatable-line);\n    background: var(--datatable-header-background);\n    color: var(--datatable-header-foreground);\n}\n\n/**********************************************************/\n/*                  SpreadSheet                           */\n/**********************************************************/\n.SpreadSheetHeader {\n  display: table-header-group;\n  max-width: 100%;\n  display: flex;\n  overflow: hidden;\n}\n\n.SpreadSheetHeaderRow {\n    display: flex;\n    overflow: hidden;\n    background: var(--spreadsheet-header-background);\n    color: var(--spreadsheet-header-foreground);\n}\n.SpreadSheetHeaderCell {\n    display: flex;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    border: 1px solid var(--spreadsheet-line);\n    border-bottom: 2px double var(--spreadsheet-line);\n}\n\n/**********************************************************/\n/*                  Loading                               */\n/**********************************************************/\n.LoadingIndicator {\n  height: 5px;\n}\n.LoadingOverlay {\n  position: absolute;\n  background: black;\n  opacity: 0.5;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
